import { call, put } from 'redux-saga/effects';
import {
    fetchAllContainersFailure,
    fetchAllContainersSuccess,
    fetchContainersByLevelsSuccess,
    fetchContainersByLevelsFailure,
} from 'src/features/resources-assignment/slice';
import { GET, getHeaders } from 'src/services/ApiService';

export function* getAllContainers(action) {
    const { activeConnectedAppId } = action.payload;
    const url = `/iambff/v1/connected-apps/${activeConnectedAppId}/corporate-structure/containers`;

    const result = yield call(GET, url, getHeaders());

    if (result.isSuccess) {
        yield put(fetchAllContainersSuccess(result.response));
    } else {
        yield put(fetchAllContainersFailure('Failed to fetch list of containers.'));
    }
}

export function* getContainersByLevels(action) {
    const { activeConnectedAppId, levelId } = action.payload;
    const url = `/iambff/v1/connected-apps/${activeConnectedAppId}/corporate-structure/levels/${levelId}/containers`;

    const result = yield call(GET, url, getHeaders());

    if (result.isSuccess) {
        yield put(fetchContainersByLevelsSuccess(result.response));
    } else {
        yield put(fetchContainersByLevelsFailure('Failed to fetch list of containers by levels.'));
    }
}
